import logo from './logo.svg';
import './App.css';
import WebPage from './components/WebPage';

function App() {
  return (
    <div className="App">
      <WebPage />
    </div>
  );
}

export default App;
